export const AUTH = 'AUTH';

export const APP_TITLE = 'Tarjeta Centroamericana';

export const ESSENCE_BASE_SIZE = {
  width: 20,
  height: 20,
  custom: (size, gain = 1) => ({
    width: size * gain,
    height: size * gain,
  }),
};
